import axios from "axios";
import { toast } from "react-toastify";

export const loginSuperAdmin = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/auth/super-admin`, data)
    .then((response) => {
      toast.success(response.data.msg);
      return response.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Super admin login failed");
      throw err;
    });
};

